import React from 'react';

import { SVGComponentProps } from './svg.types';

const TextSVG = ({
  fill = 'currentColor',
  size = '1em',
  wrapperClass,
  ...otherSvgProps
}: SVGComponentProps) => {
  return (
    <span className={`inline-block ${wrapperClass || ''}`}>
      <svg
        width={size}
        height={size}
        viewBox="0 0 24 24"
        fill="none"
        xmlns="http://www.w3.org/2000/svg"
        {...otherSvgProps}
      >
        <rect x="0.5" y="0.5" width="23" height="23" rx="1.5" fill="white" />
        <path
          d="M5.432 16H6.416L7.244 13.528H10.784L11.624 16H12.656L9.752 7.42H8.384L5.432 16ZM9.02 8.284L10.508 12.7H7.532L9.02 8.284ZM15.6659 16.108C16.5899 16.108 17.1539 15.796 17.6219 15.208V16H18.6179V11.86C18.6179 10.108 17.5259 9.616 16.3259 9.616C15.1139 9.616 13.9739 10.144 13.8419 11.572H14.8379C14.9339 10.804 15.4139 10.444 16.2779 10.444C17.2379 10.444 17.6219 10.864 17.6219 11.86V12.316H16.7219C15.1139 12.316 13.5779 12.808 13.5779 14.26C13.5779 15.544 14.5019 16.108 15.6659 16.108ZM15.7619 15.316C14.8859 15.316 14.5739 14.908 14.5739 14.26C14.5739 13.336 15.4979 13.024 16.7579 13.024H17.6219V13.804C17.6219 14.776 16.8179 15.316 15.7619 15.316Z"
          fill="#55585E"
        />
        <rect x="0.5" y="0.5" width="23" height="23" rx="1.5" stroke="#D5D7DD" />
      </svg>
    </span>
  );
};

export default TextSVG;
